<script>
import { mapActions, mapGetters } from "vuex";
import appConfig from "@/app.config";
import { required, minLength, maxLength } from "vuelidate/lib/validators"; // for validators
import Loader from "@/components/widgets/loader";
import AlertError from "@/components/alert_error";

export default {
  page: {
    title: "منصة امتنان",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Loader,
    AlertError,
  },
  data() {
    return {
      username: "",
      password: "********",
      remember: false,
      errors: [],
      submitted: false,
      tryingToLogIn: false,
      loadingButton: false,
      loading: false,
      showAlert: false,

      appMode: process.env.VUE_APP_MODE,
    };
  },
  validations: {
    username: { required, minLength: minLength(3), maxLength: maxLength(30) },
    password: { required, minLength: minLength(8), maxLength: maxLength(50) },
  },
  methods: {
    ...mapActions("auth", ["logIn"]),
    ...mapGetters("auth", ["getUser"]),
    handleError(error) {
      this.showAlert = true;
      alert(error);
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    tryToLogIn() {
      this.errors = [];
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loadingButton = true;
      this.logIn({
        username: this.username,
        password: this.password,
        remember: this.remember,
      })
        .then(() => {
          this.loading = false;
          this.loadingButton = false;
          // Redirect to the originally requested page, or to the home page
          this.$router.push({ name: this.getPageName() });
        })
        .catch((error) => {
          this.loading = false;
          this.loadingButton = false;
          this.handleError(error);
        });
    },
    getPageName() {
      let user = this.getUser();

      switch (user.type) {
        case "martyr":
          return "housingUnits.martyrs";
        case "wounded":
          return "housingUnits.woundeds";
        case "employee":
          return "housingUnits.employees";
        default:
          return "404";
      }
    },
  },
};
</script>

<template>
  <!-- <Layout> -->

  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="bg-soft-primary">
              <div class="row">
                <div class="col-12">
                  <div class="p-4">
                    <h4 class="text-center">منصة امتنان</h4>
                    <h5 style="font-size: 16px" class="text-center mt-2">
                      استمارة الوحدات السكنية
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div class="p-2 mb-3 text-center">
                <img src="@/assets/images/logo.png" alt="logo" width="65" />
              </div>

              <Loader :loading="loading">
                <b-form class="p-2" @submit.prevent="tryToLogIn">
                  <AlertError :showDismissibleAlert="showAlert" :errors="errors" />

                  <b-form-group
                    class="col-md-12 mb-3"
                    id="input-group-1"
                    label="رمز الحساب :"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      type="password"
                      v-model="username"
                      placeholder="ادخل رمز الحساب"
                      :class="{ 'is-invalid': submitted && $v.username.$error }"
                    ></b-form-input>
                    <div v-if="submitted && $v.username.$error" class="invalid-feedback">
                      <span v-if="!$v.username.required">هذا الحقل اجباري</span>
                      <span v-if="!$v.username.minLength">
                        قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 3 احرف على الاقل .
                      </span>
                      <span v-if="!$v.username.maxLength">
                        قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 30 حرف على الاكثر .
                      </span>
                    </div>
                  </b-form-group>

                  <div class="col-md-12 mt-3">
                    <b-button
                      type="submit"
                      :disabled="loadingButton"
                      variant="primary"
                      class="col-12"
                    >
                      <span v-if="!loadingButton">تسجيل دخول</span>
                      <b-spinner v-else small></b-spinner>
                    </b-button>
                  </div>
                </b-form>
              </Loader>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->

          <!-- end row -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
  </div>
  <!-- </Layout> -->
</template>

<style lang="scss" module></style>
